"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateAuthenticatedSession = void 0;
var _auth = require("@ori/auth");
var _react = require("react");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _webMessengerContext = require("../contexts/webMessengerContext");
var _utils = require("../utils");
/**
 * Due to iframe and its redirect I have to wait few seconds before I can register plugin.
 */
const useCreateAuthenticatedSession = () => {
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    codeVerifier
  } = (0, _contexts.useExternalAuth)();
  const {
    isScriptLoaded
  } = (0, _webMessengerContext.useWebMessenger)();
  (0, _react.useEffect)(() => {
    if (customerId !== _auth.NOT_LOGGED_IN_USER_ID && isScriptLoaded) {
      (0, _utils.waitAndExecute)(
      // istanbul ignore next -- Genesys API
      () =>
      // eslint-disable-next-line new-cap, @typescript-eslint/no-unsafe-return -- Genesys preset naming,
      window.Genesys?.('registerPlugin', 'AuthProvider', AuthProvider => {
        AuthProvider.registerCommand('getAuthCode', e => {
          e.resolve({
            authCode: localStorage.getItem(_constants.AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS),
            codeVerifier,
            iss: localStorage.getItem(_constants.ISSUER_STORAGE_PARAMETER_FOR_GENESYS),
            redirectUri: _constants.REDIRECT_URI
          });
          localStorage.removeItem(_constants.AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS);
        });
        AuthProvider.registerCommand('reAuthenticate', e => {
          /*
            In case there is no valid auth-code or refresh token it should again open login form but in this case we are using hidden iframe.
           */
          e.resolve(undefined);
        });
        AuthProvider.ready();
      }), _constants.MESSENGER_DELAY);
    }
  }, [codeVerifier, customerId, isScriptLoaded]);
};
exports.useCreateAuthenticatedSession = useCreateAuthenticatedSession;
